export default {
	project: {
		my_xs: 'मेरे निर्णय',
		fields: {
			name: 'शीर्षक',
			name_explanation: 'अपने प्रोजेक्ट के लिए शीर्षक दें',
			description: 'मिशन',
			description_explanation: 'अपना समग्र मिशन बताएँ',
			vision: 'विज़न',
			vision_explanation: 'परियोजना की दीर्घकालिक दृष्टि बताएँ',
			description_long: 'विवरण',
			description_long_explanation: 'उदा.: «स्विस मेकाट्रॉनिक्स SME, 200 लोग, यूरोपीय ऑटोमोटिव OEM बाज़ार। मिशन: 2030 तक स्मार्ट सेंसर का यूरोपीय अग्रणी बनना।»',
			description_long_hint: 'विवरण जितना अधिक सटीक होगा (क्षेत्र, आकार, मिशन), विश्लेषण उतना ही सटीक होगा।',
			description_long_warning_title: 'संक्षिप्त विवरण',
			description_long_warning_body: 'आपका विवरण {{count}} वर्णों का है। AI ऐसा क्षेत्र या संदर्भ अनुमान लगा सकता है जो आपके संगठन से मेल नहीं खाता। क्या आप शुरू करने से पहले इसे समृद्ध करना चाहते हैं?',
			description_long_warning_enrich: 'समृद्ध करें',
			description_long_warning_continue: 'फिर भी शुरू करें',
			ai_context: 'विशेष फोकस और दृष्टिकोण',
			ai_context_explanation: 'उन कोणों, अभिनेताओं या सीमाओं को बताएँ जिन्हें विश्लेषण प्राथमिकता दे (उदा. कोई विशिष्ट प्रतिस्पर्धी, नियामक आयाम, क्षेत्र, समय सीमा…)।',
			fishbone_description: 'रणनीतिक योजना - लक्ष्य स्थिति',
			fishbone_description_explanation: '',
			reference: 'संदर्भ',
			tags: 'टैग',
			likelihoods: 'संभावनाएँ',
			impacts: 'प्रभाव',
			types: {
				stakeholders: 'हितधारक',
				stakeholders_long: 'हितधारक प्रोजेक्ट',
				stakeholders_explanation: 'मौजूदा शक्तियों को संरेखित करें',
				risks: 'जोखिम',
				risks_long: 'जोखिम प्रोजेक्ट',
				risks_explanation: 'जोखिम को ओपनिंग में बदलें',
				pro: 'रणनीति निष्पादन',
				pro_long: 'रणनीति निष्पादन प्रोजेक्ट',
				pro_explanation: 'चुस्ती से लागू करें'
			},
			ai: {
				scenarios: {
					title: "अन्वेषण के लिए परिदृश्य",
					hint: "निजी AI द्वारा संसाधित — बाहर डेटा प्रसारित नहीं। आप पाठ, समय क्षितिज को संपादित कर सकते हैं, परिदृश्य जोड़/हटा सकते हैं।",
					worst_label: "सबसे खराब स्थिति",
					worst_default: "प्रमुख जोखिम साकार होते हैं, अवसर चूक जाते हैं, हितधारक विरोध करते हैं।",
					best_label: "सबसे अच्छी स्थिति",
					best_default: "जोखिम प्रबंधित, अवसर पकड़े गए, हितधारक सहयोग करते हैं।",
					add: "परिदृश्य जोड़ें",
					remove: "यह परिदृश्य हटाएँ",
					label_placeholder: "परिदृश्य का नाम",
					content_placeholder: "परिकल्पनाएँ, मुख्य घटनाएँ, साकार होने की शर्तें…"
				},
				horizon_unit: {
					d: "दिन",
					w: "सप्ताह",
					m: "महीने",
					y: "वर्ष"
				}
			},
		},
		messages: {
			delete_confirmation: 'प्रोजेक्ट हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई प्रोजेक्ट «{{name}}» हटाना चाहते हैं? यह पूर्ववत नहीं हो सकता।',
			clone_confirmation: 'प्रोजेक्ट क्लोन करें',
			clone_confirmation_explanation:
				'क्या आप वाकई इस प्रोजेक्ट को क्लोन करना चाहते हैं?',
			clone_in_progress: 'आपका प्रोजेक्ट क्लोन हो रहा है, कृपया प्रतीक्षा करें…',
			delete_in_progress: 'आपका प्रोजेक्ट हटाया जा रहा है, कृपया प्रतीक्षा करें…'
		},
		actions: {
			edit: 'प्रोजेक्ट विवरण संपादित करें',
			delete: 'प्रोजेक्ट हटाएँ',
			clone: 'प्रोजेक्ट क्लोन करें',
			open: 'प्रोजेक्ट खोलें'
		}
	},
	option: {
		fields: {
			name_explanation: 'कृपया इस विकल्प के लिए नाम दर्ज करें'
		}
	},
	item: {
		name: 'हितधारक',
		name_plural: 'हितधारक',
		activeness_zones: {
			external_outer_positive: 'तटस्थ',
			external_inner_positive: 'निष्क्रिय',
			external_outer_negative: 'तटस्थ',
			external_inner_negative: 'निष्क्रिय',
			internal_low_positive: 'कम',
			internal_medium_positive: 'मध्यम',
			internal_high_positive: 'उच्च',
			internal_low_negative: 'कम',
			internal_medium_negative: 'मध्यम',
			internal_high_negative: 'उच्च',
			internal_positive: 'उत्प्रेरक',
			internal_negative: 'अवरोधक'
		},
		messages: {
			delete_confirmation: 'हितधारक हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस हितधारक को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, हितधारक चुनें और दाएँ स्तंभ में «आँख» बटन से अक्षम करें।'
		},
		fields: {
			name: 'नाम',
			description: 'विवरण',
			links: {
				outcoming: { name: 'आउटगोइंग लिंक' },
				incoming: { name: 'इनकमिंग लिंक' }
			},
			stakes: { name: 'हित संबंध' },
			indicators: { name: 'संकेतक संबंध' },
			risks: { name: 'जोखिम संबंध' },
			opportunities: { name: 'ओपनिंग संबंध' },
			impact: {
				label: 'महत्व',
				level: { low: 'कम', medium: 'मध्यम', high: 'उच्च' }
			},
			trend: {
				label: 'स्वर',
				level: {
					green: 'सकारात्मक',
					neutral: 'तटस्थ',
					orange: 'जोखिम में',
					red: 'नकारात्मक'
				}
			}
		},
		actions: {
			create_new: 'नया हितधारक बनाएँ',
			edit: 'विवरण संपादित करें',
			delete: 'हितधारक हटाएँ',
			clone: 'हितधारक क्लोन करें'
		},
		no_x: 'कोई हितधारक नहीं',
		engagement: 'सहभागिता',
		importance: 'महत्व',
		trust: 'स्वर',
		levels: {
			low: 'कम',
			medium: 'मध्यम',
			high: 'उच्च',
			inactive_neutral: 'निष्क्रिय / तटस्थ',
			positive: 'सकारात्मक',
			positive_short: 'सका.',
			negative: 'नकारात्मक',
			negative_short: 'नका.',
			at_risk: 'जोखिम में',
			neutral: 'तटस्थ'
		}
	},
	item_link: {
		no_x: 'कोई लिंक नहीं',
		actions: { create_new: 'नया लिंक बनाएँ' }
	},
	item_comment: {
		no_x: 'कोई इतिहास नहीं',
		actions: { create_new: 'नया इतिहास बनाएँ' }
	},
	tag: {
		name: 'टैग',
		name_plural: 'टैग',
		fields: { name: 'टैग', name_plural: 'टैग' },
		messages: {
			delete_confirmation: 'टैग हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस टैग को हटाना चाहते हैं? यह पूर्ववत नहीं।',
			no_x: 'कोई टैग नहीं'
		},
		actions: {
			add_x: 'टैग जोड़ें',
			create_new: 'टैग बनाएँ',
			edit: 'टैग संपादित करें',
			delete: 'टैग हटाएँ'
		}
	},
	stake: {
		no_x: 'कोई हित नहीं',
		name: 'हित',
		name_plural: 'हित',
		fields: {
			name: 'नाम',
			reference: 'संदर्भ',
			name_plural: 'हित',
			description: 'विवरण',
			evaluated_at: 'अंतिम मूल्यांकन',
			weight: 'भार',
			trend: 'स्थिति',
			risks: { name: 'जोखिम संबंध', name_positive: 'ओपनिंग संबंध' },
			trend_tier: {
				strained: 'कमजोर',
				mixed: 'मिश्रित',
				solid: 'मजबूत'
			}
		},
		message: { no_x: 'कोई हित नहीं' },
		messages: {
			delete_confirmation: 'हित हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस हित को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, आइटम चुनें और दाएँ में «आँख» से अक्षम करें।'
		},
		actions: {
			delete: 'हित हटाएँ',
			edit: 'हित संपादित करें',
			create_new: 'हित बनाएँ'
		}
	},
	indicator: {
		name: 'संकेतक',
		name_plural: 'संकेतक',
		no_x: 'कोई संकेतक नहीं',
		fields: {
			indicator_category: 'श्रेणी',
			name: 'नाम',
			reference: 'संदर्भ',
			name_plural: 'संकेतक',
			evaluated_at: 'अंतिम मूल्यांकन',
			frequency: 'आवृत्ति',
			weight: 'भार',
			description: 'विवरण'
		},
		action: { add_x: 'संकेतक बिंदु जोड़ें' },
		message: { no_x: 'कोई संकेतक नहीं' },
		messages: {
			delete_confirmation: 'संकेतक हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस संकेतक को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, आइटम चुनें और «आँख» से अक्षम करें।'
		},
		actions: {
			delete: 'संकेतक हटाएँ',
			edit: 'संकेतक संपादित करें',
			create_new: 'संकेतक बनाएँ'
		}
	},
	scenario: {
		name: 'परिदृश्य',
		name_plural: 'परिदृश्य',
		no_x: 'कोई परिदृश्य नहीं',
		baseline: 'बेसलाइन',
		fields: {
			name: 'नाम',
			name_long: 'परिदृश्य नाम',
			score: 'परिदृश्य स्कोर',
			description: 'विवरण',
			impacts: 'प्रभाव विवरण',
			generate_simulation: 'सिमुलेशन स्वचालित उत्पन्न करें',
			simulation_query: 'परिकल्पना और समय सीमा'
		},
		placeholders: {
			simulation_query:
				'उदा.: यदि 2 वर्षों में तेल की कीमतें 50% बढ़ जाएँ तो क्या होगा? हितधारकों और जोखिमों पर क्या प्रभाव?'
		},
		messages: {
			delete_confirmation: 'परिदृश्य हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस परिदृश्य को हटाना चाहते हैं? यह पूर्ववत नहीं।',
			switch_scenario: 'बेसलाइन या अन्य परिदृश्य पर जाएँ',
			creation_in_progress: 'आपका परिदृश्य तैयार हो रहा है, कृपया प्रतीक्षा करें…',
			simulation_explanation:
				'AI आपकी परिकल्पना का विश्लेषण कर इस परिदृश्य का अनुकरण करने के लिए हितधारक, जोखिम और हित में संशोधन सुझाएगा।',
			promote_as_baseline: {
				title: 'इस परिदृश्य को नई बेसलाइन बनाएँ',
				explanation:
					'क्या आप वाकई परिदृश्य «<0>{{name}}</0>» को नई बेसलाइन बनाना चाहते हैं? यह पूर्ववत नहीं।',
				keep_current_baseline_as_scenario_question:
					'पुरानी बेसलाइन का क्या करें?',
				keep_current_baseline_as_scenario_question_yes:
					'रखना है, नाम दें',
				keep_current_baseline_as_scenario_question_no:
					'कुछ नहीं, हटाया जा सकता है',
				keep_scenario_question:
					'क्या नई बेसलाइन बनाए गए परिदृश्य की प्रति रखें?',
				keep_scenario_question_yes: 'हाँ, प्रति रखें',
				keep_scenario_question_no: 'नहीं, आवश्यक नहीं',
				loading: 'परिदृश्य को नई बेसलाइन बनाया जा रहा है…'
			},
			best_evaluation: 'सभी परिदृश्यों में सर्वोत्तम स्थिति'
		},
		actions: {
			create_new: 'नया परिदृश्य बनाएँ',
			create_new_from_baseline: 'बेसलाइन से नया परिदृश्य',
			save_as_new_baseline: 'नई बेसलाइन के रूप में सहेजें',
			clone: 'परिदृश्य क्लोन करें',
			edit: 'परिदृश्य संपादित करें',
			delete: 'परिदृश्य हटाएँ',
			next: 'अगला परिदृश्य',
			previous: 'पिछला परिदृश्य',
			previous_baseline: 'बेसलाइन परिदृश्य पर जाएँ'
		}
	},
	fishbone_branch: {
		name: 'शाखा',
		name_plural: 'शाखाएँ',
		fields: {
			completion: 'पूर्णता',
			trend: 'स्थिति',
			name: 'नाम',
			description: 'विवरण',
			weight: 'भार',
			responsible: 'जिम्मेदार',
			dates: 'तिथियाँ',
			startOn: 'प्रारंभ',
			endOn: 'समाप्ति'
		},
		messages: {
			delete_confirmation: 'फ़िशबोन शाखा हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस शाखा को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, शाखा चुनें और «आँख» से अक्षम करें।'
		},
		actions: {
			add: 'शाखा जोड़ें',
			clone: 'शाखा क्लोन करें',
			edit: 'शाखा संपादित करें',
			delete: 'शाखा हटाएँ'
		}
	},
	fishbone_item: {
		name: 'उप-शाखा',
		name_plural: 'उप-शाखाएँ',
		fields: {
			name: 'नाम',
			description: 'विवरण',
			completion: 'पूर्णता',
			trend: 'स्थिति',
			weight: 'भार',
			responsible: 'जिम्मेदार',
			startOn: 'प्रारंभ',
			endOn: 'समाप्ति',
			dates: 'तिथियाँ'
		},
		messages: {
			delete_confirmation: 'उप-शाखा हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस उपाय को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, उपाय चुनें और «आँख» से अक्षम करें।'
		},
		actions: {
			add: 'उप-शाखा जोड़ें',
			clone: 'उप-शाखा क्लोन करें',
			edit: 'उप-शाखा संपादित करें',
			delete: 'उप-शाखा हटाएँ'
		}
	},
	risk: {
		name: 'जोखिम',
		name_plural: 'जोखिम',
		name_positive: 'ओपनिंग',
		name_plural_positive: 'ओपनिंग',
		fields: {
			name: 'नाम',
			description: 'विवरण - घटना संकेत',
			reference: 'संदर्भ',
			risk_category: 'श्रेणी',
			likelihood: 'संभावना',
			likelihood_level: 'संभावना स्तर नाम',
			impact: 'प्रभाव',
			impact_level: 'प्रभाव स्तर नाम',
			matching_opportunity: 'मिलान ओपनिंग',
			matching_risks: 'मिलान जोखिम',
			evaluated_at: 'अंतिम मूल्यांकन',
			exposure: 'एक्सपोज़र',
			exposure_positive: 'ऊपरी लाभ',
			opportunity: { name: 'ओपनिंग' }
		},
		impacts: {
			1: 'नगण्य',
			2: 'मामूली',
			3: 'मध्यम',
			4: 'गंभीर',
			5: 'अत्यंत'
		},
		likelihoods: {
			1: 'अत्यंत असंभाव्य',
			2: 'असंभाव्य',
			3: 'संभव',
			4: 'संभाव्य',
			5: 'लगभग निश्चित'
		},
		messages: {
			delete_confirmation: 'जोखिम हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस जोखिम को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, जोखिम चुनें और «आँख» से अक्षम करें।',
			delete_opening: 'ओपनिंग हटाएँ',
			delete_opening_explanation:
				'क्या आप वाकई इस ओपनिंग को हटाना चाहते हैं? यह पूर्ववत नहीं और सभी परिदृश्यों को प्रभावित करेगा।\n\nयदि केवल इस परिदृश्य के लिए छिपाना है, तो बंद करें, ओपनिंग चुनें और «आँख» से अक्षम करें।',
			no_x: 'कोई जोखिम नहीं',
			no_category: 'कोई श्रेणी नहीं',
			no_x_positive: 'कोई ओपनिंग नहीं'
		},
		actions: {
			create_new: 'नया जोखिम या ओपनिंग बनाएँ',
			edit: 'जोखिम संपादित करें',
			edit_opportunity: 'ओपनिंग संपादित करें',
			delete: 'जोखिम हटाएँ',
			delete_opportunity: 'ओपनिंग हटाएँ'
		}
	},
	risk_category: {
		name: 'श्रेणी',
		name_plural: 'श्रेणियाँ',
		fields: { name: 'नाम' },
		messages: {
			delete_confirmation: 'श्रेणी हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस श्रेणी को हटाना चाहते हैं? यह पूर्ववत नहीं।',
			no_x: 'कोई श्रेणी नहीं'
		},
		default_values: {
			name: {
				1: 'अस्तित्वगत',
				2: 'रणनीतिक',
				3: 'परिचालन'
			}
		},
		actions: {
			create_new: 'नई श्रेणी बनाएँ',
			edit: 'श्रेणी संपादित करें',
			delete: 'श्रेणी हटाएँ',
			add_x: 'श्रेणी जोड़ें'
		}
	},
	indicator_category: {
		name: 'श्रेणी',
		name_plural: 'श्रेणियाँ',
		fields: { name: 'नाम' },
		messages: {
			delete_confirmation: 'श्रेणी हटाएँ',
			delete_confirmation_explanation:
				'क्या आप वाकई इस श्रेणी को हटाना चाहते हैं? यह पूर्ववत नहीं।',
			no_x: 'कोई श्रेणी नहीं',
			unassigned: 'अनिर्दिष्ट'
		},
		default_values: {
			name: {
				1: 'वित्तीय',
				2: 'ग्राहक',
				3: 'आंतरिक प्रक्रियाएँ',
				4: 'सीखना और विकास'
			}
		},
		actions: {
			create_new: 'नई श्रेणी बनाएँ',
			edit: 'श्रेणी संपादित करें',
			delete: 'श्रेणी हटाएँ',
			add_x: 'श्रेणी जोड़ें'
		}
	},
};
